angular.module('tf.directives')

    .directive('dots', function () {
        return{
            restrict:'E',
            replace:true,
            scope:{
                items : "="
            },
            templateUrl:'js/components/dots/dots.html',

            link: function(scope,element,attr){

                scope.select = function (index) {
                    scope.items.set(index);
                };
            }
        };
    })
;
